import { render, staticRenderFns } from "./TiktokPage.vue?vue&type=template&id=00fa8ed6&scoped=true"
import script from "./TiktokPage.vue?vue&type=script&lang=js"
export * from "./TiktokPage.vue?vue&type=script&lang=js"
import style0 from "./TiktokPage.vue?vue&type=style&index=0&id=00fa8ed6&prod&scoped=true&lang=css"
import style1 from "./TiktokPage.vue?vue&type=style&index=1&id=00fa8ed6&prod&scoped=true&lang=less"
import style2 from "./TiktokPage.vue?vue&type=style&index=2&id=00fa8ed6&prod&scoped=true&lang=css"
import style3 from "./TiktokPage.vue?vue&type=style&index=3&id=00fa8ed6&prod&lang=less&scoped=true"
import style4 from "./TiktokPage.vue?vue&type=style&index=4&id=00fa8ed6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@6.26.3_css-loader@6.10.0_vue-template-compiler@2.7.16_webpack@5.91.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fa8ed6",
  null
  
)

export default component.exports